export const mrtPaperSx = {
    backgroundColor: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    boxShadow: 'var(--shadow-1)',
    backgroundImage: 'none',
    overflow: 'hidden'
}

export const mrtTopToolbarSx = {
    backgroundColor: 'var(--surface)',
    backgroundImage: 'none',
    padding: '4px 6px 4px 18px',
    '& .MuiIconButton-root': {
        width: 34,
        height: 34,
        borderRadius: '8px',
        color: '#2d332f',
        '&:hover': { backgroundColor: '#edf1ee' }
    }
}

export const mrtBottomToolbarSx = {
    backgroundColor: 'var(--surface)',
    backgroundImage: 'none',
    borderTop: '1px solid var(--border)',
    boxShadow: 'none',
    minHeight: 55,
    '& .MuiTablePagination-root': { color: 'var(--muted)' },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': { fontSize: 12 }
}

export const mrtHeadCellSx = {
    backgroundColor: '#fbfcfb',
    borderBottom: '1px solid var(--border)',
    color: '#2a302c',
    fontSize: 12,
    fontWeight: 700,
    '& .Mui-TableHeadCell-Content-Wrapper': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}

export const mrtBodyCellSx = {
    borderBottom: '1px solid var(--border)',
    color: 'var(--ink)',
    fontSize: 12
}

export const mrtFooterCellSx = {
    backgroundColor: '#fbfcfb',
    borderTop: '1px solid var(--border)',
    color: 'var(--ink)',
    fontSize: 12,
    fontWeight: 700
}

export const mrtBodyRowSx = {
    '& > td:first-of-type': { paddingTop: 0, paddingBottom: 0 },
    '&:hover td': {
        background: 'linear-gradient(90deg, var(--green-050), #fbfffb)'
    },
    '&.Mui-selected td, &.Mui-selected:hover td': {
        background: 'linear-gradient(90deg, var(--green-050), #fbfffb)'
    }
}

export const mrtTableContainerSx = {
    borderTop: '1px solid var(--border)'
}
